const routes = {
  alexdev: "/alexdev",
  awards: "/awards",
  blog: "/blog",
  gallery: "/gallery",
  home: "/",
  home: "/",
  login: "/login",
  potfolio: "/potfolio",
  register: "/register",
};

export default routes;
